import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Navbar from './Component/Navbar';
import Editoal from './Component/Editoal';
import Homee from './Component/Homee';

import Khel from './Component/Khel';
import Study from './Component/Study';
import Health from './Component/Health';
import Bussiness from './Component/Bussiness';
import District from './Component/District';
import Footer from './Component/Footer';
import Lokshbha from './Component/Lokshbha';
import Vishanshbha from './Component/Vidhanshbha';
import Desh from './Component/Desh';
import Videsh from './Component/Videsh';
import Filmi from './Component/Filmi';
import LaguKatha from './Component/Lagukatha';
import Astrology from './Component/Astrology';
import Krishi from './Component/Krishi';
import Beuty from './Component/Beuty';
import Khabar from './Component/Khabar';
import Contact from './Component/Contact';
import Single from './Component/Single';
import All from './Component/All';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Deshsingle from './Component/Deshsingle';
import Awaranktha from './Component/Awaranktha';
import Grampanchayat from './Component/Grampanchayat';

import Dristicsingle from './Component/Dristicsingle';



const App = () => {
    return (
        <>
            <Navbar />
            <Routes>

                <Route path="" element={<Homee />} />
                <Route path="/Editoal" element={<Editoal />} />

                <Route path="/Khel" element={<Khel />} />
                <Route path="/Study" element={<Study />} />
                <Route path="/Health" element={<Health />} />
                <Route path="/Bussiness" element={<Bussiness />} />
                <Route path="/District" element={<District />} />
                <Route path="/Lokshbha" element={<Lokshbha />} />
                <Route path="/Vidhanshbha" element={<Vishanshbha />} />
                <Route path="/Desh" element={<Desh />} />
                <Route path='/Videsh' element={<Videsh />} />
                <Route path='/Filmi' element={<Filmi />} />
                <Route path='/Lagukatha' element={<LaguKatha />} />
                <Route path='/Astrology' element={<Astrology />} />
                <Route path='/Krishi' element={<Krishi />} />
                <Route path='/Beuty' element={<Beuty />} />






                <Route path="/Khabar" element={<Khabar />} />
                <Route path='/Contact' element={<Contact />} />

                <Route path='/Awaranktha' element={<Awaranktha />} />
                <Route path='/Grampanchayat' element={<Grampanchayat />} />

                <Route path='/:id' element={<Single />} />
                {/* <Route path='/All' element={<All />} /> */}
                <Route path='/countrynews/:id' element={<Deshsingle />} />
                <Route path='/districtsnews/:id' element={<Dristicsingle />} />

            </Routes>
            <Footer />

        </>
    );
};

export default App;